import { render, staticRenderFns } from "./update-list.vue?vue&type=template&id=a85275fe&scoped=true"
import script from "./update-list.vue?vue&type=script&lang=js"
export * from "./update-list.vue?vue&type=script&lang=js"
import style0 from "./update-list.vue?vue&type=style&index=0&id=a85275fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85275fe",
  null
  
)

export default component.exports